import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/chip-in";

class ChipInService {
  createChipInUnauthorized = async (body) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/unauthorized`,
        body
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while chip in.");
    }
  };

  validateChipInPayment = async ({ paymentChargeId }) => {
    try {
      const body = {
        paymentChargeId,
      };
      const response = await axiosApiClient.post(
        BASE_URL + "/validate-payment",
        body
      );
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while validating payment");
    }
  };
}

const chipInService = new ChipInService();
export default chipInService;
